<template>
  <b-modal ref="modal" lazy no-close-on-esc hide-header-close no-close-on-backdrop :hide-header="true"
    :hide-footer="true">
    <button @click="hide" type="button" aria-label="Close" class="close">×</button>

    <div class="modify-package-modal">
      <p style="font-weight: bold; text-align: center;">MODIFY PACKAGE INFO</p>
      <p style="font-size: 0.90rem">Tip: Each field works independently.&nbsp; Modify any field(s) as preferred.</p>

      <div class="card">
        <div class="card-header blue">
          <b-row>
            <b-col>Package Details</b-col>
          </b-row>
        </div>
        <div class="card-body">
          <b-form-row>
            <b-col>
              <b-form-group>
                <product-select ref="productSelect" :product_data="product_data" v-model="selectedProduct"
                  @change="onChangeProduct" @clear="onProductClear" @save="onProductSave"></product-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group>
                <!-- service class options -->
                <b-select :options="serviceOptions" v-model="selectedService"
                  :class="['form-control', 'custom-dropdown']" name="service" @change="onServiceClassChange">
                  <template slot="first">
                    <option :value="''">Select Service Class</option>
                  </template>
                </b-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group>
                <!-- package options -->
                <b-select :options="packageOptions" :class="['form-control', 'custom-dropdown']"
                  :disabled="!selectedService" v-model="selectedPackage" name="package">
                  <template slot="first">
                    <option :value="''">Select Package Type</option>
                  </template>
                </b-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group>
                <!-- MY PACKAGING -->
                <b-select :options="dimensionsPresetOptions" v-model="tmpMyPkg"
                  :disabled="!(dimensionsPresetOptions.length > 1)" class="form-control" name="customsContentType"
                  @change="onPackagingSelected">
                </b-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <!-- WEIGHT -->
            <b-col sm="2" lg="1">
              <label class="p-1">
                <b-img src="/images/icons/wgt-sm.png" width="25" v-b-tooltip.hover title="Weight" />
              </label>
            </b-col>
            <b-col sm="5" lg="2">
              <b-form-group>
                <b-form-input type="number" placeholder="LB" :class="['form-control']" v-model="weight.lb"
                  :disabled="noLB"></b-form-input>
                <!-- :class="['form-control', {'is-invalid': !noLB}]" -->
              </b-form-group>
            </b-col>
            <b-col sm="5" lg="2">
              <b-form-group>
                <input type="number" placeholder="OZ" :class="['form-control']" v-model="weight.oz" />
              </b-form-group>
            </b-col>
            <b-col sm="2" lg="1">
              <label class="pull-right p-1">
                <b-img src="/images/icons/dim-sm.png" width="25" v-b-tooltip.hover title="Dimensions" />
              </label>
            </b-col>
            <!-- DIMENSION -->
            <b-col sm="3" lg="2">
              <b-form-group>
                <input :disabled="isDimAllowed" type="number"
                  :class="['form-control', { 'is-invalid': !checkDimensions }]" placeholder="L" v-model="dimension.l" />
              </b-form-group>
            </b-col>
            <b-col sm="3" lg="2">
              <b-form-group>
                <input :disabled="isDimAllowed" type="number"
                  :class="['form-control', { 'is-invalid': !checkDimensions }]" placeholder="W" v-model="dimension.w" />
              </b-form-group>
            </b-col>
            <b-col sm="3" lg="2">
              <b-form-group>
                <input :disabled="isDimAllowed || selectedPackage === 'SOFTPACK'" type="number"
                  :class="['form-control', { 'is-invalid': !checkDimensions }]" placeholder="H" v-model="dimension.h" />
              </b-form-group>
            </b-col>
          </b-form-row>
        </div>
      </div>
      <div class="card">
        <div class="card-header blue">Additional Services</div>
        <div class="card-body">
          <b-form-row>
            <b-col>
              <!-- DELIVERY CONF -->
              <b-form-group>
                <b-select class="form-control" v-model="selectedConfirm" :options="signatureOptions"
                  @change="onChangeSignatureOptions">
                  <template slot="first">
                    <option :value="''" :disabled="selectedService == 'EM'">Select Delivery Confirmation</option>
                  </template>
                </b-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <!-- DECLARED VALUE -->
              <b-form-group>
                <b-form-input class="form-control" v-model="declaredValue" type="number" name="declared-value"
                  placeholder="Declared Value (Optional)"></b-form-input>
                <!-- @keyup.native="(e) => { onKeyUpDeclaredValue(e, null) }" -->
              </b-form-group>
            </b-col>
          </b-form-row>
          <!-- <b-form-row class="mb-2 ml-1">
            <b-col>
              <span>
                Shipsurance (Available Balance {{numeral(shipsurance).format('$0,0.00')}})
                <br>
                <b-link to="/my-account/shipsurance">Click here</b-link> to add funds and view T&C
              </span>
            </b-col>
          </b-form-row> -->
          <!-- INSURANCE -->
          <b-form-row>
            <b-col>
              <b-form-group>
                <b-select class="form-control" v-model="selectedInsurance" :options="insuranceOptions">
                  <template slot="first">
                    <option :value="''">Select Insurance</option>
                  </template>
                </b-select>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group label="Postmark Date" label-cols-sm="4">
                <b-input-group class="default">
                  <b-form-checkbox v-model="future_shipping" class="form-control-sm" :true-value="true"
                    :false-value="false" />
                  <template v-slot:append>
                    <DatePicker class="form-control" :disabled="!future_shipping" v-model="future_shipping_date"
                      :config="{
                        widgetPositioning: {
                          vertical: 'top',
                        },
                        format: 'YYYY-MM-DD',
                        minDate: moment(),
                        maxDate: moment().add('7', 'days'),
                      }" />
                  </template>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-form-row>
        </div>
      </div>

      <!-- <div class="card">
        <b-card-header class="blue"> Optional Fields </b-card-header>
        <b-card-body>
          <b-form-row>
            <b-col>
              <b-form-group>
                <b-input-group class="default">
                  <b-form-input
                    type="text"
                    placeholder="Account ID Lookup"
                    v-model="acct_id"
                    maxlength="100"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <b-form-input
                  type="text"
                  placeholder="Description"
                  v-model="description"
                  maxlength="100"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col>
              <b-form-group>
                <b-input
                  type="text"
                  class="form-control"
                  placeholder="Custom Field 1 (Prints on Label)"
                  maxlength="40"
                  v-model="label_sticky"
                ></b-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <b-input
                  type="text"
                  class="form-control"
                  placeholder="Custom Field 2 (Prints on Label)"
                  maxlength="40"
                  v-model="label_sticky_2"
                ></b-input>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-card-body>
      </div> -->
      <div class="w-100 text-right">
        <b-btn class="btn-blue" size="sm" @click="save">Apply and Close</b-btn>
      </div>
    </div>
  </b-modal>
</template>

<style lang="scss">
.modify-package-modal {
  .card {
    font-size: 0.75rem;

    .card-header {
      font-size: 0.95rem;
      padding: 0.10rem 1rem;

      .btn {
        padding: 1px 8px;
      }
    }

    .form-group {
      margin-bottom: 0.5rem;
    }

    input,
    select,
    button,
    label,
    .input-group-text {
      font-size: 0.75rem;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .dropdown {
      .dropdown-toggle {
        padding: 2px;
      }
    }
  }
}
</style>

<script>
import DatePicker from "vue-bootstrap-datetimepicker";

import { mapGetters } from "vuex";
import moment from "moment";
import insurance from "../../data/insurance";
import _ from "lodash";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      selectedProduct: null,
      selectedService: '',
      selectedPackage: null,
      tmpMyPkg: '0x0x0',
      weight: { lb: null, oz: null },
      dimension: { l: null, w: null, h: null },

      selectedConfirm: '',
      selectedInsurance: '',
      declaredValue: null,
      future_shipping: false,
      future_shipping_date: null,

      acct_id: '',
      description: '',
      label_sticky: '',
      label_sticky_2: '',

      order_items: [],

      noLB: false,
    }
  },

  computed: {
    ...mapGetters({
      user: "getUser",
      getCarrierRules: "getCarrierRules",
      getSignatureCarrierRules: "getSignatureCarrierRules",
      getInsuranceCarrierRules: "getInsuranceCarrierRules",
      getShippingService: "getShippingService",
      shipping_services: "getShippingServices",
      products: "products",
      shipsurance: "getShipsurance",
    }),

    product_data() {
      return {
        selectedProduct: this.order_items.length ? this.order_items : this.selectedProduct,
        selectedService: this.selectedService,
        selectedPackage: this.selectedPackage,
        tmpMyPkg: this.tmpMyPkg,
        weight: this.weight,
        dimensions: {
          l: this.dimension.l,
          w: this.dimension.w,
          h: this.dimension.h,
        }
      }
    },

    checkDimensions() {
      const { h, w, l } = this.dimension;

      const hasAll = h && w && l;
      if (this.selectedPackage === "SOFTPACK") {
        this.dimension.h = 1
        if (!hasAll) return false;
        return true;
      } else {
        const dim = [parseInt(h), parseInt(w), parseInt(l)];
        const hasNull = dim.some(d => isNaN(d) || d < 1)
        const hasVal = dim.some(d => d > 0)

        if (hasNull && hasVal) return false
        return true;
      }
    },

    isDimAllowed() {
      if (this.selectedPackage) {
        if (["SOFTPACK", "PKG", "IRRPKG"].includes(this.selectedPackage)) return false;
        this.dimension.l = null;
        this.dimension.h = null;
        this.dimension.w = null;
        return true;
      }
      return false;
    },

    carrierRules: function () {
      return this.getCarrierRules(this.country || 'US');
    },

    serviceRules() {
      return this.carrierRules[this.selectedService] || [];
    },

    serviceOptions() {
      try {
        let carrierRules = this.getCarrierRules('US')
        let carrierRulesInt = this.getCarrierRules('PH')
        carrierRules = Object.assign(carrierRules, carrierRulesInt);

        let options = Object.keys(carrierRules).map(serviceId => {
          return _.find(this.shipping_services, s => {
            return s && s.code === serviceId;
          });
        });

        options = _.orderBy(_.filter(options), "order");

        options = options.map(option => {
          let packageOptions = this.getPackageOptions(option.code);

          // Make sure at least 1 option exists
          if (!packageOptions.length) {
            return null;
          }

          return {
            value: option.code,
            text: option.name
          };
        });

        console.log('options', options);

        return _.filter(options);
      } catch (e) {
        return [];
      }
    },

    packageOptions() {
      if (
        _.isEmpty(this.selectedService) ||
        !this.serviceRules["parcelTypeRules"]
      ) {
        this.selectedPackage = '';
        return [];
      }

      return this.getPackageOptions(this.selectedService);
    },

    dimensionsPresetOptions() {
      let options = this.user.dimensions
        ? this.user.dimensions.map(dimension => {
          return {
            value: `${dimension.length}x${dimension.width}x${dimension.height}`,
            text: dimension.name
          };
        })
        : [];

      options = _.concat({
        value: '0x0x0',
        text: 'My Packaging',
      }, options);
      return options;
    },

    signatureOptions() {
      let options = [
        {
          value: 'DelCon',
          label: 'Delivery Confirmation (Default)',
          text: 'Delivery Confirmation (Default)'
        },
        {
          value: 'WAIVE',
          label: 'Waive Signature Confirmation',
          text: 'Waive Signature Confirmation'
        },
        {
          value: 'Sig',
          label: 'Signature Confirmation - $3.40',
          text: 'Signature Confirmation - $3.40'
        },
        {
          value: 'ADSIG',
          label: 'Adult Signature Confirmation - $9.05',
          text: 'Adult Signature Confirmation - $9.05'
        },
        {
          value: 'ADSIGRD',
          label: 'Adult Signature Required / Restricted Delivery - $9.35',
          text: 'Adult Signature Required / Restricted Delivery - $9.35'
        },
      ]

      if (['FCM', 'PM'].includes(this.selectedService)) {
        options = _.remove(options, o => {
          return o.value != null
        })
      }
      else if (this.selectedService == 'MEDIA') {
        options = [
          {
            value: 'DelCon',
            label: 'Delivery Confirmation',
            text: 'Delivery Confirmation'
          },
          {
            value: 'Sig',
            label: 'Signature Confirmation - $3.40',
            text: 'Signature Confirmation - $3.40'
          },
        ]
      } else if (this.selectedService == 'EM') {
        options = [
          {
            value: 'WAIVE',
            label: 'Waive Signature Confirmation',
            text: 'Waive Signature Confirmation'
          },
          {
            value: 'Sig',
            label: 'Signature Confirmation (included)',
            text: 'Signature Confirmation (included)'
          },
          {
            value: 'ADSIG',
            label: 'Adult Signature Confirmation',
            text: 'Adult Signature Confirmation'
          },
          {
            value: 'ADSIGRD',
            label: 'Adult Signature Required / Restricted Delivery',
            text: 'Adult Signature Required / Restricted Delivery'
          },
        ]
      }

      return options

      const rules = this.getSignatureCarrierRules(
        this.selectedService,
        this.selectedPackage,
        this.country || 'US',
        false
      );
      // if not
      if (!rules.length) {
        return [{
          value: 'DelCon',
          label: 'Delivery Confirmation (Default Tracking)',
          text: 'Delivery Confirmation (Default Tracking)'
        }];
      }

      let ruleOptions = rules.map(rule => {
        return {
          value: rule.specialServiceId,
          label: rule.brandedName,
          text: rule.brandedName
        };
      });

      return ruleOptions;
    },

    noWeight() {
      const { oz, lb } = this.weight;
      const isNull = [NaN, 0];
      if (isNull.includes(parseInt(oz)) && isNull.includes(parseInt(lb))) return true;
      return false;
    },

    insuranceOptions() {
      if (!this.user.shipsurance_terms) {
        return [];
      }

      // Domestic shipment. Just return static options
      // if (this.country === "US") {
      return [
        { value: 'none', text: 'None (Default Insurance)' },
        ...insurance.getSelectOptions()
      ]
      // }

      // International. Use shipping rules
      let rules = this.$store.getters.getInsuranceCarrierRules(
        this.order.shipping_service.code,
        this.order.package_type,
        this.shipping_address.country
      );
      const ruleOptions = rules.map(rule => {
        return {
          value: rule,
          label: rule.brandedName,
          text: rule.brandedName
        };
      });

      return ruleOptions;
    },
  },

  mounted() {
    // this.showDefaultPackageDetails()
  },

  methods: {
    moment: moment,

    showDefaultPackageDetails() {
      if (this.user.default_package && this.user.package_detail_json) {
        const user_package = JSON.parse(this.user.package_detail_json)
        console.log('user_package', user_package);
        this.selectedProduct = 'default'
        this.selectedService = user_package.selectedService
        this.selectedPackage = user_package.selectedPackage
        this.tmpMyPkg = user_package.tmpMyPkg || '0x0x0'
        this.weight = user_package.weight
        this.dimension = user_package.package
      }
    },

    getPackageOptions(serviceId) {
      // console.log("SERVICE ID", serviceId);
      let rules = this.$store.getters.getServicePackageRules(
        serviceId,
        this.country || 'US',
        true // filter inactive mail classes
      );

      // Flat Rates, this needs to be updated annually
      const flatRates = {
        EM: { // Priority Mail Express
          FRE: "$24.90",
          LGLFRENV: "$25.15",
          PFRENV: "$25.35"
        },
        PM: { // Priority Mail
          FRE: "$7.60", // Flat Rate Envelope
          SFRB: "$8.10", // Small Flat Rate Box
          LFRB: "$18.95", // Large Flat Rate Box
          LGLFRENV: "$7.90", // Legal Flat Rate Envelope
          FRB: "$14.00", // Medium Flat Rate Box
          MLFRB: "$18.35", // APO/FPO/DPO
          PFRENV: "$8.30" // Padded Flat Rate Envelope
        }
      }

      let options = serviceId
        ? rules.map(rule => {
          let name = rule.brandedName;

          if (
            serviceId in flatRates &&
            rule.parcelType in flatRates[serviceId]
          ) {
            name += " - " + flatRates[serviceId][rule.parcelType];
          }

          return {
            value: rule.parcelType,
            text: name
          };
        })
        : [];

      return options
      // return _.orderBy(options, "text");
    },

    onServiceClassChange(val) {
      this.selectedService = val;
      this.selectedPackage = 'PKG';
      this.selectedConfirm = '';

      switch (val) {
        case "FCPIS":
          if (!this.noWeight) {
            const total_weight = ((this.weight.lb || 0) * 16) + (this.weight.oz || 0);
            if (total_weight > 64) {
              this.error_msg = "Maximum weight limit for First-Class Package International is 4lbs.";
              this.weight = Object.assign({}, { lb: 0, oz: 0 });
            }
          }
          break;
        case "FCM":
          this.noLB = true;
          this.weight.lb = 0;
          break;
        case "EM":
          this.selectedConfirm = 'Sig'
        default:
          this.noLB = false;
      }
    },

    onChangeSignatureOptions() {
      if (_.find(this.signatureOptions, { value: this.selectedConfirm })) {
        return;
      }
      if (this.signatureOptions.length === 1 && this.signatureOptions[0].value === null) {
        this.selectedConfirm = '';
      } else if (this.signatureOptions.length > 1) {
        const hasDelCon = _.find(this.signatureOptions, option => {
          return option.value === "DelCon";
        });
        if (hasDelCon) {
          this.selectedConfirm = "DelCon";
        } else if (!_.isNull(this.signatureOptions[0].value)) {
          this.selectedConfirm = this.signatureOptions[0].value;
        } else {
          this.selectedConfirm = this.signatureOptions[1].value;
        }
      } else if (this.selectedConfirm === '' && this.signatureOptions.length > 0) {
        this.selectedConfirm = this.signatureOptions[0].value;
      } else if (this.signatureOptions.length === 0) {
        this.selectedConfirm = '';
      }
    },

    async onChangeProduct(id) {
      let product = _.find(this.products, p => p.id === parseInt(id));
      this.tmpMyPkg = "0x0x0";
      if (product) {
        this.order_items = [];
        product.quantity = 1;
        this.selectedProduct = product;
        this.weight = this.getWeight(product.weight)
        this.dimension.l = parseFloat(product.package_length) || null
        this.dimension.w = parseFloat(product.package_width) || null
        this.dimension.h = parseFloat(product.package_height) || null
        this.declaredValue = parseFloat(product.declared_value) || null
        // if (this.country == 'US') {
        this.selectedService = product.service_class
        this.selectedPackage = product.package_type
        // }
      }
    },

    onProductClear() {
      this.order_items = [];
      this.selectedProduct = null;
      this.selectedService = "";
      this.selectedPackage = "";
      this.declaredValue = null;
      this.tmpMyPkg = "0x0x0";
      this.weight = { lb: null, oz: null };
      this.dimension = { length: null, width: null, height: null };
    },

    async onProductSave(data) {
      this.order_items = data.selectedProduct
      this.selectedProduct = data.selectedProduct;
      this.selectedService = data.selectedService;
      this.selectedPackage = data.selectedPackage;
      this.declaredValue = data.declaredValue;
      this.tmpMyPkg = data.tmpMyPkg;
      this.weight = data.weight;
      this.dimension = {
        length: data.dimensions.l,
        width: data.dimensions.w,
        height: data.dimensions.h,
      }
      if (this.selectedService !== 'FCM') {
        this.noLB = false;
      }
    },

    onPackagingSelected(val) {
      if (!val) return;
      const [l, w, h] = val.split('x');
      this.dimension = { l: parseInt(l), w: parseInt(w), h: parseInt(h) };
    },

    getWeight(weight) {
      const lb = Math.floor(weight / 16);
      const oz = Math.round(weight % 16);
      return {
        lb: lb + (oz > 15 ? 1 : 0),
        oz: (oz > 15) ? 0 : oz
      };
    },

    show() {
      this.clear()
      this.$refs.modal.show();
    },

    hide() {
      this.$refs.modal.hide();
    },

    save() {
      const shippingService = this.getShippingService(this.selectedService);

      this.$emit('save', {
        shipping_service_id: shippingService ? shippingService.id : null,
        package_type: this.selectedPackage,
        total_weight: parseInt(this.weight.lb || 0) * 16 + parseInt(this.weight.oz || 0),
        package_length: this.dimension.l,
        package_width: this.dimension.w,
        package_height: this.dimension.h,
        confirmation: this.selectedConfirm,
        declared_value: this.declaredValue,
        insurance: this.selectedInsurance,
        future_shipping: this.future_shipping,
        future_shipping_date: this.future_shipping_date,
        order_items: this.order_items,
        acct_id: this.acct_id,
        description: this.description,
        label_sticky: this.label_sticky,
        label_sticky_2: this.label_sticky_2,
      })
      this.hide()
      this.clear()
    },

    clear() {
      this.selectedProduct = null
      this.selectedService = ''
      this.selectedPackage = ''
      this.tmpMyPkg = '0x0x0'
      this.weight = { lb: null, oz: null }
      this.dimension = { l: null, w: null, h: null }

      this.selectedConfirm = ''
      this.declaredValue = null
      this.selectedInsurance = ''
      this.future_shipping = false
      this.future_shipping_date = null

      this.order_items = []

      this.noLB = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modals/ModifyPackage.vue